interface RiskScoreBarProps {
  score: number;
}

export function RiskScoreBar({ score }: RiskScoreBarProps) {
  const clamped = Math.max(0, Math.min(100, score));

  const gradients: Record<string, string> = {
    high: 'linear-gradient(90deg, #ef4444 0%, #f87171 100%)',
    elevated: 'linear-gradient(90deg, #f97316 0%, #fb923c 100%)',
    moderate: 'linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%)',
    low: 'linear-gradient(90deg, #22c55e 0%, #4ade80 100%)',
  };

  let variant = 'low';
  if (clamped >= 80) variant = 'high';
  else if (clamped >= 60) variant = 'elevated';
  else if (clamped >= 40) variant = 'moderate';

  return (
    <div className="flex items-center gap-2">
      <div className="h-2.5 w-16 overflow-hidden rounded-full bg-gray-200 sm:w-24">
        <div
          className={[
            'animate-score-expand h-full rounded-full',
            clamped >= 80 ? 'animate-score-pulse' : '',
          ].join(' ')}
          style={{
            width: `${clamped}%`,
            background: gradients[variant],
          }}
          aria-hidden="true"
        />
      </div>
      <span className="text-sm font-medium text-gray-700">{clamped}</span>
    </div>
  );
}
